import { FC, useState } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import { Badge, Button, Divider, Flex, Space, Tabs } from 'antd'
import CreatedPrintJobs from './components/created-print-jobs/created-print-jobs'
import useCreatedPrintJobsRefresh from './components/created-print-jobs/hooks/use-created-print-jobs-refresh'
import MachinesQueues from './components/machines-queues/machines-queues'
import Summary from './components/summary/summary'
import { useTheme } from 'styled-components'
import styled from 'styled-components'
import ShiftsButton from './components/shifts-button/shifts-button'
import useRouteTab from '../../../hooks/use-route-tab'
import { dynamicRoutes } from '../../../constants/routes'

interface FlexoPageProps {}

const tabs = ['flexo', 'digital'] as const

const FlexoPage: FC<FlexoPageProps> = () => {
    const [selectedMachineBrandName, setSelectedMachineBrandName] = useState<string>('Bobst')
    const theme = useTheme()
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'flexo',
        getRoute: dynamicRoutes.schedulesFlexoTab,
    })
    const { jobs, newJobsCount, isRefreshing, handleRefresh } =
        useCreatedPrintJobsRefresh(activeKey)

    const tabsItems = [
        {
            label: 'Флексо печать',
            key: 'flexo',
            children: <CreatedPrintJobs tab='flexo' jobs={jobs} />,
        },
        {
            label: 'Цифровая печать',
            key: 'digital',
            children: <CreatedPrintJobs tab='digital' jobs={jobs} />,
        },
    ]

    return (
        <>
            <PageLayout
                title={'План флексо печати'}
                beforeUser={
                    <Space size={8}>
                        <Badge count={newJobsCount} overflowCount={99}>
                            <Button loading={isRefreshing} onClick={handleRefresh}>
                                Обновить
                            </Button>
                        </Badge>
                        <ShiftsButton />
                    </Space>
                }
            >
                <PageContent gap={24} flex={'auto'}>
                    <Summary
                        selectedMachineBrandName={selectedMachineBrandName}
                        onChangeMachineBrandName={setSelectedMachineBrandName}
                    />

                    <TabsStyled
                        activeKey={activeKey}
                        onChange={onTabChange}
                        destroyInactiveTabPane
                        type={'card'}
                        size={'large'}
                        items={tabsItems}
                    />

                    <MachinesQueues machineBrandName={selectedMachineBrandName} />
                </PageContent>
            </PageLayout>
        </>
    )
}

export default FlexoPage

const PageContent = styled(Flex)`
    height: 100%;
    min-width: 0;
`

const TabsStyled = styled(Tabs)`
    width: 1156px;
    min-width: 1156px;
    overflow: hidden;

    .ant-tabs-content-holder {
        min-width: 0;
        overflow: hidden;
    }

    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
        min-width: 0;
        overflow: hidden;
    }
`
